// import { useState, useEffect } from "react";
// import axios from "axios";
// import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button, Box, CircularProgress, Grid, Paper, Divider, useTheme, useMediaQuery, styled, Chip, Stack, IconButton, Card, CardContent, alpha, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, } from "@mui/material";
// import { History as HistoryIcon, Close as CloseIcon, CalendarToday as CalendarIcon, Person as PersonIcon, TrendingUp as TrendingUpIcon, Assignment as AssignmentIcon, AttachMoney as MoneyIcon, Comment as CommentIcon, CheckCircle as CheckCircleIcon, Cancel as CancelIcon, Pending as PendingIcon, } from "@mui/icons-material";
// import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
// import { formatRows } from "../utils/formatRows";

// // Helper to unwrap values
// const unwrap = (v, fallback = "—") =>
//   v == null ? fallback : Array.isArray(v) ? v.join(", ") : typeof v === "object" ? v.label ?? v.value ?? fallback : v;

// // Format ISO → dd-mm-yyyy
// const formatDate = (iso) => {
//   if (!iso) return "—";
//   const d = new Date(iso);
//   return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
// };

// // Styled card for master details — ensures shadow and styling in v7
// const MasterPaper = styled(Paper)(({ theme }) => ({
//   backgroundColor: "#fff",
//   border: `1px solid ${theme.palette.divider}`,
//   borderRadius: theme.shape.borderRadius * 2,
//   padding: theme.spacing(3),
//   boxShadow: theme.shadows[4], // Always visible shadow
// }));

// export default function HistoryManagement({ open, onClose, inquiryId, connectionString }) {
//   const API = connectionString;
//   const theme = useTheme();
//   const isLg = useMediaQuery(theme.breakpoints.up("lg"));

//   const [loading, setLoading] = useState(false);
//   const [master, setMaster] = useState(null);
//   const [followups, setFollowups] = useState([]);

//   // Fetch master
//   useEffect(() => {
//     if (!open || !inquiryId) {
//       setMaster(null);
//       return;
//     }
//     setLoading(true);
//     axios.get(`${API}/api/getInquiryHistory`, { params: { inquiryId } })
//       .then((r) => {
//         const d = r.data.data ?? (Array.isArray(r.data.enquiries) && r.data.enquiries[0]);
//         setMaster(d || null);
//       })
//       .catch(() => setMaster(null))
//       .finally(() => setLoading(false));
//   }, [open, inquiryId, API]);

//   // Fetch follow-ups
//   useEffect(() => {
//     if (!open || !inquiryId) {
//       setFollowups([]);
//       return;
//     }
//     axios.get(`${API}/api/getInquiryFollowup`, { params: { inquiryId } })
//       .then((r) => {
//         const list = Array.isArray(r.data.data) ? r.data.data : Array.isArray(r.data.enquiries) ? r.data.enquiries : [];
//         setFollowups(formatRows(list));
//       })
//       .catch(() => setFollowups([]));
//   }, [open, inquiryId, API]);

//   // Build items only once master is loaded
//   const items = master ? [
//     ["Inquiry No.", master.InqNo],
//     ["Date", formatDate(master.InqDate)],
//     ["Next Follow-Up", formatDate(master.NextFollowUpDate)],
//     ["Lead Source", master.LeadSourceName],
//     ["Employee", master.EmployeeName],
//   ] : [];

//   // Helper functions for status styling
//   const getStatusIcon = (status) => {
//     const statusLower = status?.toLowerCase() || '';
//     if (statusLower.includes('success') || statusLower.includes('completed')) {
//       return <CheckCircleIcon sx={{ fontSize: 20, color: 'success.main' }} />;
//     }
//     if (statusLower.includes('fail') || statusLower.includes('cancel')) {
//       return <CancelIcon sx={{ fontSize: 20, color: 'error.main' }} />;
//     }
//     return <PendingIcon sx={{ fontSize: 20, color: 'warning.main' }} />;
//   };

//   const getStatusColor = (status) => {
//     const statusLower = status?.toLowerCase() || '';
//     if (statusLower.includes('success') || statusLower.includes('completed')) {
//       return 'success';
//     }
//     if (statusLower.includes('fail') || statusLower.includes('cancel')) {
//       return 'error';
//     }
//     return 'warning';
//   };

//   return (
//     <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg" PaperProps={{ sx: { borderRadius: 4, maxWidth: 1100, maxHeight: '90vh', }, }} >
//       {/* HEADER */}
//       <DialogTitle sx={{ position: "sticky", top: 0, zIndex: 10, bgcolor: "background.paper", borderBottom: "1px solid", borderColor: "divider", py: 2, px: 3, }}>
//         <Stack direction={{ xs: "column", md: "row" }} alignItems={{ xs: "flex-start", md: "center" }} justifyContent="space-between" spacing={2} >
//           {/* Left : Title */}
//           <Typography variant="h6" fontWeight={700}>
//             Inquiry History
//           </Typography>

//           {/* Right : Inquiry Overview (compact) */}
//           {master && (
//             <Stack direction="row" spacing={3} flexWrap="wrap" sx={{ fontSize: "0.87rem", py: 1, px: 3, borderRadius: 2 }} >
//               {items.map(([label, val]) => (
//                 <Box key={label}>
//                   <Typography color="text.secondary" sx={{ fontWeight: 500 }} variant="body1">
//                     {label}
//                   </Typography>
//                   <Typography variant="body2" fontWeight={500}>
//                     {unwrap(val)}
//                   </Typography>
//                 </Box>
//               ))}
//             </Stack>
//           )}

//           <IconButton onClick={onClose} size="small">
//             <CloseIcon />
//           </IconButton>
//         </Stack>
//       </DialogTitle>


//       {/* <DialogContent sx={{ py: 3, px: 3, bgcolor: 'grey.50' }}> */}
//       {master ? (
//         <Box sx={{ pb: 3, pt: 1.5, px: 3, bgcolor: 'rgba(252, 252, 252, 1)' }}>
//           {/* ================= Follow-ups Table ================= */}
//           <Box sx={{ position: "sticky", top: 72, zIndex: 5, pb: 1 }} >
//             <Typography variant="subtitle1" fontWeight={600}>
//               Follow-Up Activity ({followups.length})
//             </Typography>
//           </Box>


//           {followups.length > 0 ? (
//             <TableContainer component={Paper} sx={{ maxHeight: 450, borderRadius: 2, border: "1px solid", borderColor: "divider", }} >
//               <Table stickyHeader size="small" sx={{ tableLayout: "fixed", "& td, & th": { whiteSpace: "normal", wordBreak: "break-word", verticalAlign: "top", }, }} >
//                 {/* ===== TABLE HEADER ===== */}
//                 <TableHead>
//                   <TableRow sx={{ "& th": { bgcolor: "grey.50", fontWeight: 600, fontSize: "0.85rem", py: 1, }, }} >
//                     <TableCell width={40}>#</TableCell>
//                     <TableCell width={110}>Date</TableCell>
//                     <TableCell width={110}>Lead Source</TableCell>
//                     <TableCell width={110}>Assigned To</TableCell>
//                     <TableCell>Requirement</TableCell>
//                     <TableCell>Remark</TableCell>
//                     <TableCell width={90}>Offer</TableCell>
//                     <TableCell width={90}>Closing</TableCell>
//                     <TableCell width={90}>Status</TableCell>
//                   </TableRow>
//                 </TableHead>

//                 {/* ===== TABLE BODY ===== */}
//                 <TableBody>
//                   {followups.map((f, i) => (
//                     <TableRow
//                       key={f.FollowupId}
//                       hover
//                       sx={{
//                         "& td": {
//                           fontSize: "0.85rem",
//                           py: 0.8,
//                         },
//                       }}
//                     >
//                       <TableCell>{i + 1}</TableCell>

//                       <TableCell>{formatDate(f.NextFollowupDate)}</TableCell>

//                       <TableCell>{unwrap(f.LeadSourceName) || "-"}</TableCell>

//                       <TableCell>{unwrap(f.EmployeeName) || "-"}</TableCell>

//                       <TableCell>
//                         {Array.isArray(f.Requirement)
//                           ? f.Requirement.join(", ")
//                           : unwrap(f.Requirement) || "-"}
//                       </TableCell>

//                       <TableCell>{unwrap(f.Remark) || "-"}</TableCell>

//                       <TableCell>{unwrap(f.OfferPrice) || "-"}</TableCell>

//                       <TableCell>{unwrap(f.ClosingPrice) || "-"}</TableCell>

//                       <TableCell>{unwrap(f.StatusName) || "-"}</TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>

//           ) : (
//             <Paper elevation={0} sx={{ py: 8, textAlign: 'center', borderRadius: 3, border: '1px dashed', borderColor: 'divider', bgcolor: 'background.paper', }} >
//               <HistoryIcon sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }} />
//               <Typography variant="h6" color="text.secondary" fontWeight={600}>
//                 No Follow-Up Records
//               </Typography>
//               <Typography variant="body2" color="text.secondary" mt={1}>
//                 There are no follow-up activities recorded for this inquiry yet.
//               </Typography>
//             </Paper>
//           )}
//         </Box>
//       ) : (
//         <Paper elevation={0} sx={{ py: 8, textAlign: 'center', borderRadius: 3, border: '1px dashed', borderColor: 'divider', bgcolor: 'background.paper', }} >
//           <HistoryIcon sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }} />
//           <Typography variant="h6" color="text.secondary" fontWeight={600}>
//             No History Found
//           </Typography>
//           <Typography variant="body2" color="text.secondary" mt={1}>
//             No inquiry history available for ID: {inquiryId}
//           </Typography>
//         </Paper>
//       )}
//       {/* </DialogContent> */}

//       {/* FOOTER */}
//       <DialogActions sx={{ p: 3, borderTop: '1px solid', borderColor: 'divider', bgcolor: 'background.paper', }} >
//         <Button variant="contained" onClick={onClose} > Close </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }













import { colors as themeColors } from '../utils/theme';
import { useState, useEffect } from "react";
import axios from "axios";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button, Box, CircularProgress, Grid, Paper, Divider, useTheme, useMediaQuery, styled, Chip, Stack, IconButton, Card, CardContent, alpha, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Avatar, } from "@mui/material";
import { History as HistoryIcon, Close as CloseIcon, CalendarToday as CalendarIcon, Person as PersonIcon, TrendingUp as TrendingUpIcon, Assignment as AssignmentIcon, AttachMoney as MoneyIcon, Comment as CommentIcon, CheckCircle as CheckCircleIcon, Cancel as CancelIcon, Pending as PendingIcon, } from "@mui/icons-material";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { formatRows } from "../utils/formatRows";

// Helper to unwrap values
const unwrap = (v, fallback = "—") =>
  v == null ? fallback : Array.isArray(v) ? v.join(", ") : typeof v === "object" ? v.label ?? v.value ?? fallback : v;

// Format ISO → dd-mm-yyyy
const formatDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
};

// Styled card for master details — ensures shadow and styling in v7
const MasterPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: themeColors.neutral.surface,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius * 2,
  padding: theme.spacing(3),
  boxShadow: theme.shadows[4], // Always visible shadow
}));

export default function HistoryManagement({ open, onClose, inquiryId, connectionString }) {
  const API = connectionString;
  const theme = useTheme();
  const isLg = useMediaQuery(theme.breakpoints.up("lg"));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md")); // Check if screen is small

  const [loading, setLoading] = useState(false);
  const [master, setMaster] = useState(null);
  const [followups, setFollowups] = useState([]);

  // Fetch master
  useEffect(() => {
    if (!open || !inquiryId) {
      setMaster(null);
      return;
    }
    setLoading(true);
    axios.get(`${API}/api/getInquiryHistory`, { params: { inquiryId } })
      .then((r) => {
        const d = r.data.data ?? (Array.isArray(r.data.enquiries) && r.data.enquiries[0]);
        setMaster(d || null);
      })
      .catch(() => setMaster(null))
      .finally(() => setLoading(false));
  }, [open, inquiryId, API]);

  // Fetch follow-ups
  useEffect(() => {
    if (!open || !inquiryId) {
      setFollowups([]);
      return;
    }
    axios.get(`${API}/api/getInquiryFollowup`, { params: { inquiryId } })
      .then((r) => {
        const list = Array.isArray(r.data.data) ? r.data.data : Array.isArray(r.data.enquiries) ? r.data.enquiries : [];
        setFollowups(formatRows(list));
      })
      .catch(() => setFollowups([]));
  }, [open, inquiryId, API]);

  // Build items only once master is loaded
  const items = master ? [
    ["Inquiry No.", master.InqNo],
    ["Date", formatDate(master.InqDate)],
    ["Next Follow-Up", formatDate(master.NextFollowUpDate)],
    ["Lead Source", master.LeadSourceName],
    ["Employee", master.EmployeeName],
  ] : [];

  // Helper functions for status styling
  const getStatusIcon = (status) => {
    const statusLower = status?.toLowerCase() || '';
    if (statusLower.includes('success') || statusLower.includes('completed')) {
      return <CheckCircleIcon sx={{ fontSize: 20, color: 'success.main' }} />;
    }
    if (statusLower.includes('fail') || statusLower.includes('cancel')) {
      return <CancelIcon sx={{ fontSize: 20, color: 'error.main' }} />;
    }
    return <PendingIcon sx={{ fontSize: 20, color: 'warning.main' }} />;
  };

  const getStatusColor = (status) => {
    const statusLower = status?.toLowerCase() || '';
    if (statusLower.includes('success') || statusLower.includes('completed')) {
      return 'success';
    }
    if (statusLower.includes('fail') || statusLower.includes('cancel')) {
      return 'error';
    }
    return 'warning';
  };

  // Render follow-ups as cards for small screens
  const renderFollowupCards = () => {
    if (followups.length === 0) {
      return (
        <Paper elevation={0} sx={{ py: 8, textAlign: 'center', borderRadius: 3, border: '1px dashed', borderColor: 'divider', bgcolor: 'background.paper', }} >
          <HistoryIcon sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }} />
          <Typography variant="h6" color="text.secondary" fontWeight={600}>
            No Follow-Up Records
          </Typography>
          <Typography variant="body2" color="text.secondary" mt={1}>
            There are no follow-up activities recorded for this inquiry yet.
          </Typography>
        </Paper>
      );
    }

    return (
      <Box sx={{ maxHeight: 450, overflowY: 'auto', pr: 1 }}>
        {followups.map((f, i) => (
          <Card key={f.FollowupId} sx={{ mb: 2, borderRadius: 1, boxShadow: 2, border: '1px solid', borderColor: 'divider', }} >
            <CardContent sx={{ p: 2.5 }}>
              {/* Header: Index and Status */}
              <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                <Chip label={`Follow-up #${i + 1}`} size="small" sx={{ fontWeight: 600, bgcolor: 'primary.main', color: 'white', fontSize: '0.75rem' }} />
                <Chip icon={getStatusIcon(f.StatusName)} label={unwrap(f.StatusName) || "-"} size="small" color={getStatusColor(f.StatusName)} sx={{ fontWeight: 600, fontSize: '0.75rem' }} />
              </Stack>

              <Divider sx={{ mb: 2 }} />

              {/* Details Grid */}
              <Grid container spacing={2}>
                {/* Date */}
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                    <CalendarIcon sx={{ fontSize: 20, color: 'primary.main', mt: 0.3 }} />
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="caption" color="text.secondary" fontWeight={600} display="block">
                        Follow-up Date
                      </Typography>
                      <Typography variant="body2" fontWeight={600} color="text.primary">
                        {formatDate(f.NextFollowupDate)}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                {/* Lead Source */}
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                    <TrendingUpIcon sx={{ fontSize: 20, color: 'success.main', mt: 0.3 }} />
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="caption" color="text.secondary" fontWeight={600} display="block">
                        Lead Source
                      </Typography>
                      <Typography variant="body2" fontWeight={600} color="text.primary">
                        {unwrap(f.LeadSourceName) || "-"}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                {/* Assigned To */}
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                    <PersonIcon sx={{ fontSize: 20, color: 'info.main', mt: 0.3 }} />
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="caption" color="text.secondary" fontWeight={600} display="block">
                        Assigned To
                      </Typography>
                      <Typography variant="body2" fontWeight={600} color="text.primary">
                        {unwrap(f.EmployeeName) || "-"}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                {/* Requirement */}
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                    <AssignmentIcon sx={{ fontSize: 20, color: 'warning.main', mt: 0.3 }} />
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="caption" color="text.secondary" fontWeight={600} display="block">
                        Requirement
                      </Typography>
                      <Typography variant="body2" fontWeight={500} color="text.primary" sx={{ wordBreak: 'break-word' }}>
                        {Array.isArray(f.Requirement)
                          ? f.Requirement.join(", ")
                          : unwrap(f.Requirement) || "-"}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                {/* Remark */}
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                    <CommentIcon sx={{ fontSize: 20, color: 'secondary.main', mt: 0.3 }} />
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="caption" color="text.secondary" fontWeight={600} display="block">
                        Remark
                      </Typography>
                      <Typography variant="body2" fontWeight={500} color="text.primary" sx={{ wordBreak: 'break-word' }}>
                        {unwrap(f.Remark) || "-"}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Divider />
                </Grid>

                {/* Prices */}
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                    <MoneyIcon sx={{ fontSize: 20, color: 'success.main', mt: 0.3 }} />
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="caption" color="text.secondary" fontWeight={600} display="block">
                        Offer Price
                      </Typography>
                      <Typography variant="body2" fontWeight={700} color="success.main">
                        ₹{unwrap(f.OfferPrice) || "0"}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                    <CurrencyRupeeIcon sx={{ fontSize: 20, color: 'primary.main', mt: 0.3 }} />
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="caption" color="text.secondary" fontWeight={600} display="block">
                        Closing Price
                      </Typography>
                      <Typography variant="body2" fontWeight={700} color="primary.main">
                        ₹{unwrap(f.ClosingPrice) || "0"}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        ))}
      </Box>
    );
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg" PaperProps={{ sx: { borderRadius: 4, maxWidth: 1100, maxHeight: '90vh', }, }} >
      {/* HEADER */}
      <DialogTitle sx={{ position: "sticky", top: 0, zIndex: 10, bgcolor: "background.paper", borderBottom: "1px solid", borderColor: "divider", py: 2, px: { xs: 2, md: 3 }, }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
          {/* Left : Title */}
          <Typography variant="h6" fontWeight={700} sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' } }}>
            Inquiry History
          </Typography>

          {/* Close Button - Properly positioned */}
          <IconButton onClick={onClose} size="small" sx={{ ml: 'auto', bgcolor: 'grey.100', '&:hover': { bgcolor: 'grey.200' } }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Stack>

        {/* Inquiry Overview - Moved below title for small screens */}
        {master && (
          <Stack direction={{ xs: "column", sm: "row" }} spacing={{ xs: 1, sm: 3 }} flexWrap="wrap" sx={{ fontSize: "0.87rem", mt: 2, pt: 2, borderTop: '1px solid', borderColor: 'divider' }} >
            {items.map(([label, val]) => (
              <Box key={label}>
                <Typography color="text.secondary" sx={{ fontWeight: 500, fontSize: { xs: '0.75rem', md: '0.875rem' } }} variant="body2">
                  {label}
                </Typography>
                <Typography variant="body2" fontWeight={600} sx={{ fontSize: { xs: '0.85rem', md: '0.9rem' } }}>
                  {unwrap(val)}
                </Typography>
              </Box>
            ))}
          </Stack>
        )}
      </DialogTitle>


      {master ? (
        <Box sx={{ pb: 3, pt: 1.5, px: { xs: 2, md: 3 }, bgcolor: 'rgba(252, 252, 252, 1)' }}>
          {/* ================= Follow-ups Section ================= */}
          <Box sx={{ pb: 1.5 }} >
            <Typography variant="subtitle1" fontWeight={600} sx={{ fontSize: { xs: '1rem', md: '1.1rem' } }}>
              Follow-Up Activity ({followups.length})
            </Typography>
          </Box>

          {/* Conditional Rendering: Table or Cards */}
          {isSmallScreen ? (
            // Small Screen: Cards
            renderFollowupCards()
          ) : (
            // Medium/Large Screen: Table
            followups.length > 0 ? (
              <TableContainer component={Paper} sx={{ maxHeight: 450, borderRadius: 2, border: "1px solid", borderColor: "divider", }} >
                <Table stickyHeader size="small" sx={{ tableLayout: "fixed", "& td, & th": { whiteSpace: "normal", wordBreak: "break-word", verticalAlign: "top", }, }} >
                  {/* ===== TABLE HEADER ===== */}
                  <TableHead>
                    <TableRow sx={{ "& th": { bgcolor: "grey.50", fontWeight: 600, fontSize: "0.85rem", py: 1, }, }} >
                      <TableCell width={40}>#</TableCell>
                      <TableCell width={110}>Date</TableCell>
                      <TableCell width={110}>Lead Source</TableCell>
                      <TableCell width={110}>Assigned To</TableCell>
                      <TableCell>Requirement</TableCell>
                      <TableCell>Remark</TableCell>
                      <TableCell width={90}>Offer</TableCell>
                      <TableCell width={90}>Closing</TableCell>
                      <TableCell width={90}>Status</TableCell>
                    </TableRow>
                  </TableHead>

                  {/* ===== TABLE BODY ===== */}
                  <TableBody>
                    {followups.map((f, i) => (
                      <TableRow
                        key={f.FollowupId}
                        hover
                        sx={{
                          "& td": {
                            fontSize: "0.85rem",
                            py: 0.8,
                          },
                        }}
                      >
                        <TableCell>{i + 1}</TableCell>

                        <TableCell>{formatDate(f.NextFollowupDate)}</TableCell>

                        <TableCell>{unwrap(f.LeadSourceName) || "-"}</TableCell>

                        <TableCell>{unwrap(f.EmployeeName) || "-"}</TableCell>

                        <TableCell>
                          {Array.isArray(f.Requirement)
                            ? f.Requirement.join(", ")
                            : unwrap(f.Requirement) || "-"}
                        </TableCell>

                        <TableCell>{unwrap(f.Remark) || "-"}</TableCell>

                        <TableCell>{unwrap(f.OfferPrice) || "-"}</TableCell>

                        <TableCell>{unwrap(f.ClosingPrice) || "-"}</TableCell>

                        <TableCell>{unwrap(f.StatusName) || "-"}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Paper elevation={0} sx={{ py: 8, textAlign: 'center', borderRadius: 3, border: '1px dashed', borderColor: 'divider', bgcolor: 'background.paper', }} >
                <HistoryIcon sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }} />
                <Typography variant="h6" color="text.secondary" fontWeight={600}>
                  No Follow-Up Records
                </Typography>
                <Typography variant="body2" color="text.secondary" mt={1}>
                  There are no follow-up activities recorded for this inquiry yet.
                </Typography>
              </Paper>
            )
          )}
        </Box>
      ) : (
        <Paper elevation={0} sx={{ py: 8, textAlign: 'center', borderRadius: 3, border: '1px dashed', borderColor: 'divider', bgcolor: 'background.paper', mx: { xs: 2, md: 3 }, my: 3 }} >
          <HistoryIcon sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }} />
          <Typography variant="h6" color="text.secondary" fontWeight={600}>
            No History Found
          </Typography>
          <Typography variant="body2" color="text.secondary" mt={1}>
            No inquiry history available for ID: {inquiryId}
          </Typography>
        </Paper>
      )}

      {/* FOOTER */}
      <DialogActions sx={{ p: { xs: 2, md: 3 }, borderTop: '1px solid', borderColor: 'divider', bgcolor: 'background.paper', }} >
        <Button variant="contained" onClick={onClose} fullWidth={isSmallScreen} > Close </Button>
      </DialogActions>
    </Dialog>
  );
}